import { render } from "./RankingList.vue?vue&type=template&id=5ddd5d10&scoped=true"
import script from "./RankingList.vue?vue&type=script&lang=js"
export * from "./RankingList.vue?vue&type=script&lang=js"

import "./RankingList.vue?vue&type=style&index=0&id=5ddd5d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddd5d10"]])

export default __exports__